import {Component, OnInit} from '@angular/core';
import {CommonService} from "../../core/services/common.service";
import {CartService} from "../../core/services/cart.service";
import {HttpClientService} from "../../core/services/http-client.service";
import {ToastService} from "../../core/services/toast.service";
import {Router} from "@angular/router";
import {WindowRefService} from "../../window-ref.service";

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit{

  cartData: any[] = [];
  cartTotal: number = 0;
  cartDiscount: number = 0;
  selectedAddress: any;
  selectedEMIPlan: any;
  addressModal:boolean = false;
  isLoggedIn: boolean = false;
  customer: any;

  constructor(private common: CommonService, private router: Router, private http: HttpClientService, private cartService: CartService, private toast: ToastService, private winRef: WindowRefService) { }

  ngOnInit() {
    this.cartService.cart$.subscribe(cart => {
      this.cartData = cart;
      this.cartTotal = (this.getTotalPrice(cart));
      this.cartDiscount = (cart.reduce((total, el) => total + (parseInt(String(el.mrp * el.quantity), 10) - parseInt(String(el.sellingPrice * el.quantity), 10)), 0)).toFixed(2);
    });
    this.isLoggedIn = this.common.isLoggedIn();
    this.customer = this.common.getStorage('customer');
  }

  getSelectedAddress(address: any) {
    this.selectedAddress = address
  }

  getTotalPrice(items): number {
    return items.reduce((total, item) => {
      const policyPrice = item.pendingOrderItemPolicyPlan?.price ? Number(item.pendingOrderItemPolicyPlan.price) : 0;
      const itemTotal = (item.sellingPrice + policyPrice) * item.quantity;
      return total + itemTotal;
    }, 0);
  }

  getPaymentMode(mode) {
    if (!this.selectedAddress) {
      this.toast.info("Please choose a address first");
      return;
    }
    const params = {
      "customerAddressId": this.selectedAddress.id,
      "createPendingOrderItem": this.cartData.map((item) => ({
        itemId: item.itemId,
        sellingPrice: item.sellingPrice,
        smartSellerId: item.smartSellerId,
        quantity: item.quantity,
        pendingOrderItemPolicyPlan: item.pendingOrderItemPolicyPlan || null
      })),
      "customerId": this.customer.id,
      "totalAmount": this.getTotalPrice(this.cartData),
      "paidAmount": 0,
      "payMethod": mode,
      "selectedEMIPlan": this.selectedEMIPlan
    }
    this.http.post(`/store/confirmOrder`, params).subscribe({
      next: (res) => {
        if (res.responseStatus.toLowerCase() == 'success' && res.response) {
          if (params.payMethod == 'POD') {
            this.cartService.clearCart();
            this.toast.info(`Order Placed Successfully`);
            this.router.navigate(["/order-status/" + res.response.poId]);
          } else {
            this.payOnline(params.payMethod, res.response);
          }
        } else {
          this.toast.info(`Error occurred`);
        }
      },
      error: (err) => {
        this.toast.info(`Something went wrong`);
      }
    });
  }

  private payOnline(mode, response) {
    if (mode == 'RZ'){
      this.razorPayHandler(response);
    } else {
      //CC Avenue
      this.ccAvenueHandler(response);
    }
  }

  private razorPayHandler(val) {
    const options: any = {
      key: val.key,
      amount: val.amount,
      currency: 'INR',
      name: '',
      description: '',
      image: '',
      order_id: val.orderId,
      poId: val.poId,
      modal: {
        escape: false,
      },

      prefill: {
        name: this.customer.firstName,
        email: this.customer.emailId,
        contact: this.customer.mobileNumber,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#d3181f'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;

      this.http.postWithParams("checkout/razor-pay-response", response)
        .subscribe(data => {
          if (data.responseStatus == 'SUCCESS') {
            this.toast.success("successfully submit");
            this.cartService.clearCart();
            this.router.navigate(["/order-status/" + data.response.id]);
          } else {
            this.toast.error("Please try after some time.");
          }
        }, error => {
          if (error.statusCode == 400) {
            this.toast.error(error.response.message)
          } else {
            this.toast.error("Something went wrong")
          }
        });
    });

    options.modal.ondismiss = (() => {
      let obj = { razorpay_order_id : val.orderId }

      this.http.postWithParams("/old/checkout/razor-pay-cancelled", obj)
        .subscribe(data => {  },
        error => {
          if (error.statusCode == 400) {
            this.toast.error(error.response.message)
          } else {
            this.toast.error("Something went wrong")
          }
        });
      });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  private ccAvenueHandler(val) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = val.action;

    const encRequestInput = document.createElement('input');
    encRequestInput.type = 'hidden';
    encRequestInput.name = 'encRequest';
    encRequestInput.value = val.encRequest;
    form.appendChild(encRequestInput);

    const accessCodeInput = document.createElement('input');
    accessCodeInput.type = 'hidden';
    accessCodeInput.name = 'access_code';
    accessCodeInput.value = val.access_code;
    form.appendChild(accessCodeInput);

    document.body.appendChild(form);
    form.submit();
  }

  getEMIPlan(event: any) {
    this.selectedEMIPlan = event;
  }
}
